module.exports = __webpack_public_path__ + "static/media/robot.8c7093bd.svg";